module.exports = "https://static-production.npmjs.com/7a7ffabbd910fc60161bc04f2cee4160.png";